import type { RoutedActionHandler } from "../../app/actions.ts";

export interface TaskCollectionActionCapabilities {
  duplicate(id: string): void | Promise<void>;
  skipOccurrence(id: string): void | Promise<void>;
  toggleArchive(id: string): void | Promise<void>;
  togglePin(id: string): void | Promise<void>;
  toggleFavorite(id: string): void | Promise<void>;
  advancedFilter(): void | Promise<void>;
  overview(): void;
  clearSearch(): void | Promise<void>;
  clearFilters(): void | Promise<void>;
  removeFilter?(key?: string): void | Promise<void>;
  browseScope?(): void | Promise<void>;
}

const names = new Set(["duplicate-task", "skip-next-occurrence", "toggle-task-archive", "toggle-pin", "toggle-favorite-task", "advanced-filter", "task-overview", "clear-task-search", "clear-active-filters", "remove-visible-filter", "browse-task-scope"]);

export function createTaskCollectionActionHandler(capabilities: TaskCollectionActionCapabilities): RoutedActionHandler {
  return async (name, target) => {
    if (!names.has(name)) return false;
    const id = target.dataset.id || "";
    if (name === "duplicate-task") await capabilities.duplicate(id);
    if (name === "skip-next-occurrence") await capabilities.skipOccurrence(id);
    if (name === "toggle-task-archive") await capabilities.toggleArchive(id);
    if (name === "toggle-pin") await capabilities.togglePin(id);
    if (name === "toggle-favorite-task") await capabilities.toggleFavorite(id);
    if (name === "advanced-filter") await capabilities.advancedFilter();
    if (name === "task-overview") capabilities.overview();
    if (name === "clear-task-search") await capabilities.clearSearch();
    if (name === "clear-active-filters") await capabilities.clearFilters();
    if (name === "remove-visible-filter") await capabilities.removeFilter?.(target.dataset.filterKey);
    if (name === "browse-task-scope") await capabilities.browseScope?.();
    return true;
  };
}
